import { useStatsig } from '@atlassian/mpac-feature-flags';
import { FluidContainer } from '@atlassian/mpac-primitives';
import { FlagsImplementationProvider, Route } from '@atlassian/mpac-ui';
import { UrlUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Switch } from 'react-router';
import { addFlag, removeFlag } from '../actions/Flags';
import { discoverRoute, manageRoute } from '../constants/Routes';
import { makeEmceeFlag } from '../records/Flag';
import { useMountPath } from './AppContext';
import Discover, { EmceeInstallationLock } from './Discover';
import Flags from './Flags';
import InstallAppDialog from './InstallAppDialog';
import ManageRoutes from './Manage';
export default function AppInner(props) {
  const mountPath = useMountPath();
  const dispatch = useDispatch();
  const {
    enableEmceeAetherExperience
  } = useStatsig();
  const isAetherExp = enableEmceeAetherExperience();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlagsImplementationProvider, {
    value: {
      showFlag: flag => dispatch(addFlag({
        flag: makeEmceeFlag(flag)
      })),
      dismissFlag: key => dispatch(removeFlag(key))
    }
  }, /*#__PURE__*/React.createElement(InstallAppDialog, {
    bootstrapConfig: props.bootstrapConfig,
    context: props.selectedContext,
    hostConfig: props.hostConfig,
    hostInfo: props.hostInfo,
    links: props.links,
    selectedContext: props.selectedContext
  })), /*#__PURE__*/React.createElement(Flags, {
    hostConfig: props.hostConfig
  }), /*#__PURE__*/React.createElement(EmceeInstallationLock, {
    hostConfig: props.hostConfig,
    hostInfo: props.hostInfo
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: UrlUtils.joinPathNames([mountPath, discoverRoute.path]),
    render: routeProps => /*#__PURE__*/React.createElement(Discover, {
      algoliaClient: props.algoliaClient,
      bootstrapConfig: props.bootstrapConfig,
      featureFlags: props.featureFlags,
      history: routeProps.history,
      hostConfig: props.hostConfig,
      links: props.links,
      onRendered: props.onRendered,
      selectedContext: props.selectedContext,
      hostInfo: props.hostInfo
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: UrlUtils.joinPathNames([mountPath, manageRoute.path]),
    render: routeProps => {
      const Wrapper = isAetherExp ? FluidContainer : React.Fragment;
      return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ManageRoutes, {
        bootstrapConfig: props.bootstrapConfig,
        algoliaClient: props.algoliaClient,
        currentUserId: props.currentUserId,
        history: routeProps.history,
        hostConfig: props.hostConfig,
        links: props.links,
        onRendered: props.onRendered,
        selectedContext: props.selectedContext,
        hostInfo: props.hostInfo,
        hostPricing: props.hostPricing
      }));
    }
  }))));
}